import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import toast from 'react-hot-toast';
import {
  MdThumbUp, MdThumbDown, MdOutlineThumbUp, MdOutlineThumbDown,
} from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';

import { postedAt } from '../utils';
import { userShape } from './ThreadItem';
import { asyncDownvoteComment, asyncNeutralizeCommentVote, asyncUpvoteComment } from '../states/detailThread/actions';

const CommentItem = ({
  id, content, createdAt, owner, upVotesBy, downVotesBy,
}) => {
  const dispatch = useDispatch();
  const { authUser = null } = useSelector((states) => states);

  const onUpvote = () => {
    if (authUser === null) {
      toast.error('You must be logged in to vote.');
      return;
    }
    dispatch(asyncUpvoteComment(id));
  };

  const onDownvote = () => {
    if (authUser === null) {
      toast.error('You must be logged in to vote.');
      return;
    }
    dispatch(asyncDownvoteComment(id));
  };

  const onNeutralizeVote = () => {
    if (authUser === null) {
      toast.error('You must be logged in to vote.');
      return;
    }
    dispatch(asyncNeutralizeCommentVote(id));
  };

  const IsAuthUserUpvoted = upVotesBy.includes(authUser?.id);

  const IsAuthUserDownvoted = downVotesBy.includes(authUser?.id);

  return (
    <li className="p-6 md:px-8 flex flex-col gap-4 shadow-md rounded-md border border-[#EAEAEA] bg-white">
      <div className="flex items-center gap-4">
        <img src={owner.avatar} alt="thread owner's avatar" className="w-[40px] rounded-full" />
        <div className="grid gap-1">
          <h4 className="text-sm font-normal tracking-wider text-black">
            {owner.name}
            {' '}
            {authUser?.id === owner.id ? (<em>(You)</em>) : ''}
          </h4>
          <p className="text-xs text-[#808080] tracking-wider font-normal">{postedAt(createdAt)}</p>
        </div>
      </div>
      <div className="font-normal text-sm text-black tracking-wider">
        {parse(content)}
      </div>
      <div className="flex items-center gap-3.5">
        <button type="button" className="font-normal text-sm text-[#808080] tracking-wide flex items-center gap-0.5" onClick={IsAuthUserUpvoted ? onNeutralizeVote : onUpvote}>
          {IsAuthUserUpvoted
            ? <MdThumbUp color="#000" className="opacity-70" fontSize={16} /> : <MdOutlineThumbUp fontSize={16} /> }
          {' '}
          {upVotesBy.length}
        </button>
        <button type="button" className="font-normal text-sm text-[#808080] tracking-wide flex items-center gap-0.5" onClick={IsAuthUserDownvoted ? onNeutralizeVote : onDownvote}>
          {IsAuthUserDownvoted
            ? <MdThumbDown color="#000" className="opacity-70" fontSize={16} /> : <MdOutlineThumbDown fontSize={16} /> }
          {' '}
          {downVotesBy.length}
        </button>
      </div>
    </li>
  );
};

const commentShape = {
  id: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  owner: PropTypes.shape(userShape).isRequired,
  upVotesBy: PropTypes.arrayOf(userShape.id).isRequired,
  downVotesBy: PropTypes.arrayOf(userShape.id).isRequired,
};

CommentItem.propTypes = {
  ...commentShape,
};

export { commentShape };

export default CommentItem;
